
import {getKyc} from '../api/getKyc';
import {setGetKycAction} from '../action';

const setGetKyc = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getKyc(params);
            
            if (data.status === 'success') {
                dispatch(setGetKycAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetKyc
}